import { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './sidebar.scss';
import styled from 'styled-components';
import AuthService from "../../services/auth.service";
import LogoPU from "./static/img/pu-logo.png";

import {
    VStack,
    HStack,
    Text,
} from '@chakra-ui/react';

const ImageCard = styled.img`
    width: 20%;
    height: 20%;
    margin-left: 15px;
    object-fit: cover;
    border-radius: 50px;
    @media screen and (max-width: 873px){
        width: 285px;
        max-height: 115px;
        margin-left: 38px;
     };
`;

const currentUser = AuthService.getCurrentUser();
const sidebarNavItems = [
    {
        display: 'Verifikasi Proposal Magang',
        icon: <i className='bx bx-folder'></i>,
        to: '/admin/verifikasi/proposal',
        section: 'proposal'
    },
    {
        display: 'Verifikasi Pembayaran',
        icon: <i className='bx bx-group'></i>,
        to: '/admin/verifikasi/pembayaran',
        section: 'pembayaran'
    },
    {
        display: 'Kembali',
        icon: <i className='bx bx-home'></i>,
        to: '/',
        section: 'home'
    },
]

const SidebarAdmin = () => {
    const [activeIndex, setActiveIndex] = useState(0);
    const [stepHeight, setStepHeight] = useState(0);
    const sidebarRef = useRef();
    const indicatorRef = useRef();
    const location = useLocation();
    const [currentUser, setCurrentUser] = useState([]);

    useEffect(() => {
        const user = AuthService.getCurrentUser();
    
        if (user) {
            setCurrentUser(user);
        }
    }, [])

    useEffect(() => {
        setTimeout(() => {
            const sidebarItem = sidebarRef.current.querySelector('.sidebar__menu__item');
            indicatorRef.current.style.height = `${sidebarItem.clientHeight}px`;
            setStepHeight(sidebarItem.clientHeight);
        }, 50);
    });

    useEffect(() => {
        const curPath = window.location.pathname.split('/')[3];
        const activeItem = sidebarNavItems.findIndex(item => item.section === curPath);
        setActiveIndex(curPath.length === 0 ? 0 : activeItem);
    }, [location]);

    return (
    <div>
        <div className='sidebar'>
            <div className="sidebar__logo">
                Dashboard 
            </div>
            <HStack pb={8}>
                <ImageCard src={LogoPU}/>
                <VStack align='stretch'>
                    <span style={{fontSize: '18px', fontWeight: '700'}}>Admin</span>
                </VStack>
            </HStack>   
            <Text style={{fontSize: '14px', fontWeight: '700'}} pl={6} pt={4} pb={6}> Halaman Akun </Text>
            <div ref={sidebarRef} className="sidebar__menu">
                {
                    sidebarNavItems.map((item, index) => (
                        <Link to={item.to} key={index}>
                            <div className={`sidebar__menu__item ${activeIndex === index ? 'active' : ''}`}>
                                <div className="sidebar__menu__item__icon">
                                    {item.icon}
                                </div>
                                <div className="sidebar__menu__item__text">
                                    {item.display}
                                </div>
                            </div>
                        </Link>
                    ))
                }
            </div>
        </div>
    </div>);
};

export default SidebarAdmin;